module.exports = __webpack_public_path__ + "img/mu.e375d17f.svg";